import BookingConfirmationDetails from 'components/Content/Happening/BookingConfirmationDetails/BookingConfirmationDetails';

import { withBookingConfirmationDetailsProps } from 'viewModel/happening/withBookingConfirmationDetailsProps';

export default withBookingConfirmationDetailsProps(BookingConfirmationDetails);
